module.exports = __webpack_public_path__ + "img/bg-orange.c5abbdf8.png";